var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !!_vm.data.length ? _c('div', {
    staticClass: "c--customer-reviews customer-reviews-wrapper home-container-padding"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "airgsm-container mx-auto"
  }, [_c('div', {
    staticClass: "customer-reviews-header"
  }, [_c('h2', {
    staticClass: "title-h2"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('components.customer.reviews.title')) + "\n        ")])]), _vm._v(" "), _vm.isLoading || _vm.isCreating ? _c('div', {
    staticClass: "customer-reviews-loader"
  }, [_c('client-only', [_c('v-lottie', {
    attrs: {
      "position": "fixed"
    }
  })], 1)], 1) : !_vm.isLoading ? _c('div', {
    staticClass: "customer-reviews",
    class: {
      'customer-reviews-creating': _vm.isCreating
    }
  }, [_c('swiper', {
    ref: "customerReviewSwiper",
    attrs: {
      "options": _vm.swiperOption,
      "dir": _vm.$dir()
    },
    on: {
      "slideChangeTransitionStart": _vm.onSwiperSlideChangeTransitionStart,
      "slideChange": _vm.onSlideChange
    }
  }, [_vm._l(_vm.data, function (item, index) {
    return _c('swiper-slide', {
      key: `customer-reviews-item-${index}`
    }, [_c('ReviewItem', {
      attrs: {
        "class-prefix": "customer-reviews-item",
        "item": item,
        "close-less-more": _vm.closeLessMore,
        "is-less-more-prevent": _vm.activeIndex !== index
      },
      on: {
        "activeCollapsed": _vm.activeCollapsed
      }
    })], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('button', [_c('span', {
    staticClass: "airalo-icon-arrow-right tw-text-7"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('button', [_c('span', {
    staticClass: "airalo-icon-arrow-right tw-text-7"
  })])])], 2)], 1) : _vm._e()])])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }